import { render, staticRenderFns } from "./RsaPazienteConsensiPage.vue?vue&type=template&id=38d40a55"
import script from "./RsaPazienteConsensiPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteConsensiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports